module.exports = __webpack_public_path__ + "static/img/公司logo.174878c4.png";